export default {
  SHOW_MODAL: 'SHOW_MODAL',
  SUBMIT_MODAL: 'SUBMIT_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  UPDATE_MODAL: 'UPDATE_MODAL',
} as const;
